import React from 'react';
import { Beer, Pizza, Users, Truck, ShoppingBag, Shield } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Pizza,
      title: 'Pizzas a la Parrilla',
      description: 'Nuestra especialidad: pizzas cocidas en parrilla con ese sabor único y ahumado.',
    },
    {
      icon: Beer,
      title: 'Cervezas Artesanales',
      description: 'Amplia variedad de cervezas para acompañar tu comida.',
    },
    {
      icon: Users,
      title: 'Picadas Abundantes',
      description: 'Porciones generosas para compartir con amigos y familia.',
    },
    {
      icon: ShoppingBag,
      title: 'Para Llevar',
      description: 'Retirá tu pedido en el local cuando más te convenga.',
    },
    {
      icon: Truck,
      title: 'Delivery',
      description: 'Pedinos por Pedidos Ya y te lo llevamos a tu casa.',
    },
    {
      icon: Shield,
      title: 'Entrega Sin Contacto',
      description: 'Modalidad de entrega segura disponible.',
    },
  ];

  return (
    <section id="nosotros" className="py-16 md:py-24 bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Un Clásico de <span className="text-[#7cb342]">Rosario</span>
          </h2>
          <p className="font-body text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
            En Cosme Alberdi combinamos lo mejor de un pub con la tradición gastronómica rosarina. 
            Un lugar para disfrutar buena comida, buenas bebidas y mejor compañía.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="card-hover bg-[#252525] rounded-xl p-6 md:p-8 border border-[#333333]"
            >
              <div className="w-12 h-12 bg-[#7cb342]/10 rounded-lg flex items-center justify-center mb-4">
                <feature.icon size={24} className="text-[#7cb342]" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-white mb-2">
                {feature.title}
              </h3>
              <p className="font-body text-gray-400 text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
